export const RU = "ru";
export const RUS = "rus";
export const EN = "en";
export const GBR = "gbr";
